import { useMemo } from 'react';

import { ScreenerSettingName } from '@/hooks/screener-settings';
import { useCurrentUser } from '@/hooks/useCurrentUser';

import { useGetScreenerSettingValue } from './useGetScreenerSettingValue';

export function useShowReferralsBeyondAccess(): boolean {
  const { value } = useGetScreenerSettingValue(
    ScreenerSettingName.ShowReferralsBeyondAccess
  );
  return value === 'enabled';
}

export function useAccessibleFacilityIds(): Set<string> {
  const currentUser = useCurrentUser().data;
  return useMemo(
    () =>
      new Set(
        currentUser?.user_facility_accesses?.map((a) => a.facility_id) ?? []
      ),
    [currentUser?.user_facility_accesses]
  );
}
